import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('NiotaClassic.Devices.upload')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('media-file-upload', {
          attrs: {
            "type": 'file',
            "title": _vm.$i18n_t('NiotaClassic.Devices.form.csvUpload'),
            "buttonIcon": 'fal fa-file-csv'
          },
          on: {
            "file": _vm.uploadedFile
          }
        }), _c('core-button', {
          attrs: {
            "color": "danger",
            "title": _vm.$i18n_t('Common.cancel'),
            "prepend-icon": "fa-times"
          },
          on: {
            "click": _vm.backToList
          }
        })];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "pl-6 pr-6 pb-4",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    staticClass: "mx-0 px-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', {
    attrs: {
      "title": null
    }
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c(VIcon, {
    staticClass: "image",
    attrs: {
      "color": _vm.color,
      "large": ""
    }
  }, [_vm._v("fal fa-file-upload")]), _c('div', {
    staticClass: "ml-4"
  }, [_c('span', [_c('br'), _vm._v("\n              " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.csvUploadSubTitle')) + "\n            ")])])], 1), _c(VCard, {
    staticClass: "dt-card-text-01 px-4 py-0 mt-0 mb-0"
  }, [_c(VRow, [_c(VCol, {
    staticClass: "mb-0 mt-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('custom-fields-display-field', {
    attrs: {
      "type": 'textarea',
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.introduction'),
      "value": _vm.$i18n_t('NiotaClassic.Devices.form.introductionHint')
    }
  })], 1), _c(VCol, {
    staticClass: "mb-0 mt-0 pt-0",
    attrs: {
      "cols": "12",
      "md": "12"
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('span', {
    staticClass: "label pb-2"
  }, [_vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.howToUse')) + "\n                ")]), _c('br'), _c('ol', {
    attrs: {
      "type": "1"
    }
  }, [_c('li', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_1')))]), _c('li', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_2')))]), _c('li', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_3')))]), _c('li', [_vm._v(_vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_4')))]), _c('li', [_vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_5')) + "\n                    "), _c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-layer-plus")]), _vm._v("\n                    " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_5_1')) + "\n                  ")], 1), _c('ol', {
    attrs: {
      "type": "a"
    }
  }, [_c('li', [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-times")]), _vm._v("\n                      : " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_6')) + "\n                    ")], 1), _c('li', [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-check-circle")]), _vm._v("\n                      : " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_7')) + "\n                    ")], 1)]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_8')) + "\n                ")]), _c('p', [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-file-download")]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.l_9')) + ":\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.table.clickHere')) + "\n                  "), _c('a', {
    attrs: {
      "href": "./res/template_csv_device_creation.csv",
      "download": ""
    }
  }, [_c('b', [_c(VIcon, {
    attrs: {
      "color": _vm.color,
      "dark": "",
      "small": ""
    }
  }, [_vm._v("fal fa-link")])], 1)]), _vm._v("\n                  " + _vm._s(_vm.$i18n_t('NiotaClassic.Devices.form.toDownload')) + "\n                ")], 1)])])], 1)], 1), _c('niota-classic-devices-upload-form', {
    ref: "uploadForm"
  })], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };